export { OptionsModal as Modal, OptionsModalContent as Content } from '../sharedStyles';
